/**
 * View split left and right parts, default 50% 50% relation
 *
 */
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";

const useRowViewStyles = makeThemedStyles("RowView", (theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
}));
const RowView = (
  props: React.PropsWithChildren<{
    partWidths?: string[];
    gap?: string;
    className?: string;
    justifyContent?: string;
  }>
) => {
  const styles = useRowViewStyles();
  return (
    <div
      className={styles.root}
      style={{
        gap: props.gap,
        justifyContent: props.justifyContent,
      }}
    >
      {props.children}
    </div>
  );
};

export default RowView;
